/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersListAll } from '../../models/members-list-all';

export interface GetAllMembersApiV2MembersAllGet$Params {
  name?: (string | null);
  excludeAssignedToOrg?: (boolean | null);
  includeNonMembers?: (boolean | null);
  censorData?: boolean;
  org: string;
}

export function getAllMembersApiV2MembersAllGet(http: HttpClient, rootUrl: string, params: GetAllMembersApiV2MembersAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MembersListAll>>> {
  const rb = new RequestBuilder(rootUrl, getAllMembersApiV2MembersAllGet.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('excludeAssignedToOrg', params.excludeAssignedToOrg, {});
    rb.query('includeNonMembers', params.includeNonMembers, {});
    rb.query('censorData', params.censorData, {});
    rb.query('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MembersListAll>>;
    })
  );
}

getAllMembersApiV2MembersAllGet.PATH = '/api/v2/members/all';
